import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Alert } from "react-bootstrap";
import IconText from "../components/IconText";
import { LOADING_ICON } from "../icons";
export default function LoadingBar(props) {
    return (_jsx(Alert, { variant: "light", className: classNames("bg-light", { border: props.border !== false, "border-0": props.border === false, "mb-0": props.border === false }), ...props.alert, children: _jsx(IconText, { ...props.icon ?? LOADING_ICON, children: props.title ?? "Loading..." }) }));
}
